"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _impression = _interopRequireDefault(require("./impression"));

var CCProductImpression = function CCProductImpression(props) {
  var impressionProps = {
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    id: props.id,
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    children: props.children,
    eventName: 'CC_IMPRESSION_EVENT',
    eventData: {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      cardNetworkFilter: props.cardNetworkFilter,
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      creditScoreFilter: props.creditScoreFilter,
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      feesFilter: props.feesFilter,
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      financialInstitutionsFilter: props.financialInstitutionsFilter,
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      monthlySpendFilter: props.monthlySpendFilter,
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      yearsWithCardFilter: props.yearsWithCardFilter,
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      issuer: props.issuer,
      impressionHeader: {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productId: props.productId,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productSlug: props.productSlug,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productLocation: props.productLocation,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        category: props.category,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productInstance: props.productInstance,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        linkType: props.linkType,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        sponsored: props.sponsored,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        monetizing: props.monetizing,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productPosition: props.productPosition,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        sectionPosition: props.sectionPosition,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        offerVersionId: props.offerVersionId,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        pageNumber: props.pageNumber,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productDisplayDriver: props.productDisplayDriver
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement(_impression.default, impressionProps);
};

CCProductImpression.propTypes = {
  id: _propTypes.default.string.isRequired,
  productId: _propTypes.default.string.isRequired,
  productSlug: _propTypes.default.string.isRequired,
  productLocation: _propTypes.default.string.isRequired,
  children: _propTypes.default.element,
  category: _propTypes.default.string,
  productInstance: _propTypes.default.string,
  linkType: _propTypes.default.string,
  sponsored: _propTypes.default.bool,
  monetizing: _propTypes.default.bool,
  productPosition: _propTypes.default.number,
  sectionPosition: _propTypes.default.number,
  offerVersionId: _propTypes.default.string,
  pageNumber: _propTypes.default.number,
  cardNetworkFilter: _propTypes.default.string,
  creditScoreFilter: _propTypes.default.string,
  feesFilter: _propTypes.default.string,
  financialInstitutionsFilter: _propTypes.default.string,
  monthlySpendFilter: _propTypes.default.number,
  yearsWithCardFilter: _propTypes.default.number,
  issuer: _propTypes.default.string,
  productDisplayDriver: _propTypes.default.string
};
CCProductImpression.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types -- directive added automatically by Shepherd migration
  productLocation: 'body',
  productInstance: 'unknown',
  linkType: 'unknown',
  category: 'Credit Card'
};
var _default = CCProductImpression;
exports.default = _default;